const QUOTED_FONT_NAME = /'(.*?)'/;
const FALLBACK_SEPARATOR = ',';

export function getFontName(fontFamily: string): string {
  const quotedName = fontFamily.match(QUOTED_FONT_NAME);

  if (quotedName) {
    return quotedName[1];
  }

  return fontFamily.split(FALLBACK_SEPARATOR)[0].trim();
}
